<div class="share">
  <button class="share-button" (click)="share()">
    <mat-icon [svgIcon]="'share'" class="share-icon"></mat-icon>
    Share My Dashboard
  </button>
</div>
